// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wqV1xCTlVAU4CCkI8F0m {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  justify-content: center;
  align-items: center;
}
.NGkInzs1LjrpufGVlpti {
  position: absolute;
  top: var(--campaign-panel-center-top, 260px);
  line-height: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
}
.NGkInzs1LjrpufGVlpti[data-variant='panel'] .glCk5yaZvQPQV6jzfAAN {
  font-size: 25px;
  line-height: 18px;
  margin-bottom: var(--campaign-panel-title-margin-bottom, 20px);
}
.NGkInzs1LjrpufGVlpti[data-variant='panel'] .glCk5yaZvQPQV6jzfAAN[data-variant='card'] {
  font-size: 25px;
}
.yAOfvB4N4fUznbzNZuN5 {
  position: absolute;
  cursor: pointer;
  top: 356px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 19px;
  text-transform: uppercase;
  font-weight: 600;
  text-align: center;
  color: white;
}
.GtGNyCsMCGqbBODJUzkb {
  width: 100%;
  margin: 6px auto 9px;
  width: 240px;
  height: 1.2px;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.75) 50%, rgba(255, 255, 255, 0) 100%);
}
.glCk5yaZvQPQV6jzfAAN {
  font-family: var(--font-family-secondary, inherit);
  pointer-events: none;
  font-weight: 450;
  letter-spacing: 0.02em;
  display: flex;
  justify-content: center;
  color: white;
  text-transform: uppercase;
  font-size: 19px;
  line-height: 16px;
}
.glCk5yaZvQPQV6jzfAAN[data-variant='card'] {
  font-size: 17px;
}
@media (max-width: 767px) and (orientation: portrait) {
  .glCk5yaZvQPQV6jzfAAN[data-variant='card'] {
    font-size: 14px;
  }
}
.glCk5yaZvQPQV6jzfAAN[data-view='single'][data-has-many='false'] {
  font-size: 16px;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .NGkInzs1LjrpufGVlpti {
    top: var(--campaign-panel-center-top, 168px);
  }
  .NGkInzs1LjrpufGVlpti[data-variant='panel'] .glCk5yaZvQPQV6jzfAAN {
    font-size: 19px;
    line-height: 16px;
    margin-bottom: var(--campaign-panel-title-margin-bottom, 10px);
  }
  .NGkInzs1LjrpufGVlpti[data-variant='panel'] .glCk5yaZvQPQV6jzfAAN[data-variant='card'] {
    font-size: 17px;
  }
  .yAOfvB4N4fUznbzNZuN5 {
    top: 239px;
    font-size: 13px;
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: portrait) {
  .NGkInzs1LjrpufGVlpti {
    top: var(--campaign-panel-center-top, 157px);
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: portrait) {
  .NGkInzs1LjrpufGVlpti {
    top: var(--campaign-panel-center-top, 157px);
  }
}
}
}
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: portrait) {
  .NGkInzs1LjrpufGVlpti[data-has-many='true'] {
    top: var(--campaign-panel-center-top, 160px);
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: portrait) {
  .NGkInzs1LjrpufGVlpti[data-has-many='true'] {
    top: var(--campaign-panel-center-top, 160px);
  }
}
}
}
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: portrait) {
  .yAOfvB4N4fUznbzNZuN5 {
    top: 229px;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: portrait) {
  .yAOfvB4N4fUznbzNZuN5 {
    top: 229px;
  }
}
}
}
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: portrait) {
  .yAOfvB4N4fUznbzNZuN5[data-has-many='true'] {
    top: 230px;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: portrait) {
  .yAOfvB4N4fUznbzNZuN5[data-has-many='true'] {
    top: 230px;
  }
}
}
}
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: portrait) {
  .wqV1xCTlVAU4CCkI8F0m {
    height: 276px;
  }
  .wqV1xCTlVAU4CCkI8F0m[data-has-many='true'] {
    height: 272px;
  }
  .GtGNyCsMCGqbBODJUzkb {
    width: 200px;
    margin: 7px auto 8px;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: portrait) {
  .wqV1xCTlVAU4CCkI8F0m {
    height: 276px;
  }
  .wqV1xCTlVAU4CCkI8F0m[data-has-many='true'] {
    height: 272px;
  }
  .GtGNyCsMCGqbBODJUzkb {
    width: 200px;
    margin: 7px auto 8px;
  }
}
}
}
}
@media (min-width: 768px), (orientation: landscape) {
  .wqV1xCTlVAU4CCkI8F0m {
    min-width: var(--campaign-panel-width);
  }
}
@media (orientation: portrait) {
  .wqV1xCTlVAU4CCkI8F0m {
    background-size: 375px auto;
    background-position: top center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/shared/CampaignPanel/panel.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,8DAA8D;AAChE;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,yHAAyH;AAC3H;AACA;EACE,kDAAkD;EAClD,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,4CAA4C;EAC9C;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,8DAA8D;EAChE;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;IACV,eAAe;EACjB;AACF;AACA;AAAA;EACE;IACE,4CAA4C;EAC9C;AACF;AAAA;AAJA;AAAA;AAAA;AAAA;EACE;IACE,4CAA4C;EAC9C;AACF;AAAA;AAAA;AAAA;AACA;AAAA;EACE;IACE,4CAA4C;EAC9C;AACF;AAAA;AAJA;AAAA;AAAA;AAAA;EACE;IACE,4CAA4C;EAC9C;AACF;AAAA;AAAA;AAAA;AACA;AAAA;EACE;IACE,UAAU;EACZ;AACF;AAAA;AAJA;AAAA;AAAA;AAAA;EACE;IACE,UAAU;EACZ;AACF;AAAA;AAAA;AAAA;AACA;AAAA;EACE;IACE,UAAU;EACZ;AACF;AAAA;AAJA;AAAA;AAAA;AAAA;EACE;IACE,UAAU;EACZ;AACF;AAAA;AAAA;AAAA;AACA;AAAA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,oBAAoB;EACtB;AACF;AAAA;AAXA;AAAA;AAAA;AAAA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,oBAAoB;EACtB;AACF;AAAA;AAAA;AAAA;AACA;EACE;IACE,sCAAsC;EACxC;AACF;AACA;EACE;IACE,2BAA2B;IAC3B,+BAA+B;EACjC;AACF","sourcesContent":[".panelContainer {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  position: relative;\n  justify-content: center;\n  align-items: center;\n}\n.centerInfoWrapper {\n  position: absolute;\n  top: var(--campaign-panel-center-top, 260px);\n  line-height: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n}\n.centerInfoWrapper[data-variant='panel'] .campaignInfoTitle {\n  font-size: 25px;\n  line-height: 18px;\n  margin-bottom: var(--campaign-panel-title-margin-bottom, 20px);\n}\n.centerInfoWrapper[data-variant='panel'] .campaignInfoTitle[data-variant='card'] {\n  font-size: 25px;\n}\n.periodWrapper {\n  position: absolute;\n  cursor: pointer;\n  top: 356px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  font-size: 19px;\n  text-transform: uppercase;\n  font-weight: 600;\n  text-align: center;\n  color: white;\n}\n.separator {\n  width: 100%;\n  margin: 6px auto 9px;\n  width: 240px;\n  height: 1.2px;\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.75) 50%, rgba(255, 255, 255, 0) 100%);\n}\n.campaignInfoTitle {\n  font-family: var(--font-family-secondary, inherit);\n  pointer-events: none;\n  font-weight: 450;\n  letter-spacing: 0.02em;\n  display: flex;\n  justify-content: center;\n  color: white;\n  text-transform: uppercase;\n  font-size: 19px;\n  line-height: 16px;\n}\n.campaignInfoTitle[data-variant='card'] {\n  font-size: 17px;\n}\n@media (max-width: 767px) and (orientation: portrait) {\n  .campaignInfoTitle[data-variant='card'] {\n    font-size: 14px;\n  }\n}\n.campaignInfoTitle[data-view='single'][data-has-many='false'] {\n  font-size: 16px;\n}\n@media (--campaign-mobile) {\n  .centerInfoWrapper {\n    top: var(--campaign-panel-center-top, 168px);\n  }\n  .centerInfoWrapper[data-variant='panel'] .campaignInfoTitle {\n    font-size: 19px;\n    line-height: 16px;\n    margin-bottom: var(--campaign-panel-title-margin-bottom, 10px);\n  }\n  .centerInfoWrapper[data-variant='panel'] .campaignInfoTitle[data-variant='card'] {\n    font-size: 17px;\n  }\n  .periodWrapper {\n    top: 239px;\n    font-size: 13px;\n  }\n}\n@media (--campaign-mobile) and (orientation: portrait) {\n  .centerInfoWrapper {\n    top: var(--campaign-panel-center-top, 157px);\n  }\n}\n@media (--campaign-mobile) and (orientation: portrait) {\n  .centerInfoWrapper[data-has-many='true'] {\n    top: var(--campaign-panel-center-top, 160px);\n  }\n}\n@media (--campaign-mobile) and (orientation: portrait) {\n  .periodWrapper {\n    top: 229px;\n  }\n}\n@media (--campaign-mobile) and (orientation: portrait) {\n  .periodWrapper[data-has-many='true'] {\n    top: 230px;\n  }\n}\n@media (--campaign-mobile) and (orientation: portrait) {\n  .panelContainer {\n    height: 276px;\n  }\n  .panelContainer[data-has-many='true'] {\n    height: 272px;\n  }\n  .separator {\n    width: 200px;\n    margin: 7px auto 8px;\n  }\n}\n@media (min-width: 768px), (orientation: landscape) {\n  .panelContainer {\n    min-width: var(--campaign-panel-width);\n  }\n}\n@media (orientation: portrait) {\n  .panelContainer {\n    background-size: 375px auto;\n    background-position: top center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panelContainer": `wqV1xCTlVAU4CCkI8F0m`,
	"centerInfoWrapper": `NGkInzs1LjrpufGVlpti`,
	"campaignInfoTitle": `glCk5yaZvQPQV6jzfAAN`,
	"periodWrapper": `yAOfvB4N4fUznbzNZuN5`,
	"separator": `GtGNyCsMCGqbBODJUzkb`
};
export default ___CSS_LOADER_EXPORT___;
